import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";

import Home from "./pages/Home"
import Investor from "./pages/Investor"
import About from "./pages/About"
import Contact from "./pages/Contact"
import Pricing from "./pages/Pricing"

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" ><Home /></Route>
        <Route path="/investor"><Investor /></Route>
        <Route path="/about"><About /></Route>
        <Route path="/contact"><Contact /></Route>
        <Route path="/pricing"><Pricing /></Route>
      </Switch>
    </Router>
  );
}

export default App;